import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_SCORE_BAND_REQUEST = 'FETCH_SCORE_BAND_REQUEST';
export const FETCH_SCORE_BAND_SUCCESS = 'FETCH_SCORE_BAND_SUCCESS';
export const FETCH_SCORE_BAND_FAILURE = 'FETCH_SCORE_BAND_FAILURE';

const buildScoreBandUrl = (languageCode) => buildUrl(`/score-bands/languages/${languageCode}`);

export function getApiCallState(state, languageCode) {
  return ApiCall.find(state, { method: 'GET', url: buildScoreBandUrl(languageCode) });
}

export function fetchScoreBandIfNeeded(languageCode) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildScoreBandUrl(languageCode) })) {
      return false;
    }

    return dispatch(fetchScoreBand(languageCode));
  };
}

export function fetchScoreBand(languageCode) {
  return (dispatch) => {
    const url = buildUrl(`/score-bands/languages/${languageCode}`);
    const method = 'GET';

    const promise = dispatch(fetchScoreBandRequest()).payload
      .then((response) => dispatch(fetchScoreBandSuccess(response)))
      .catch((error) => dispatch(fetchScoreBandFailure(error)));

    function fetchScoreBandRequest() {
      return ApiCall.createAction({
        type: FETCH_SCORE_BAND_REQUEST,
        payload: fetch(url),
        url,
        method,
        languageCode,
      });
    }

    function fetchScoreBandSuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_SCORE_BAND_SUCCESS,
        payload,
        url,
        method,
        languageCode,
      });
    }

    function fetchScoreBandFailure(error) {
      return ApiCall.createAction({
        type: FETCH_SCORE_BAND_FAILURE,
        error,
        url,
        method,
        languageCode,
      });
    }

    return promise;
  };
}



// WEBPACK FOOTER //
// ./data/ScoreBand/actions.js